"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAgendaSlotByIdResponseSchema = void 0;
const zod_1 = require("zod");
const agenda_slot_1 = require("./agenda-slot");
const agenda_slot_reservation_1 = require("./agenda-slot-reservation");
exports.getAgendaSlotByIdResponseSchema = zod_1.z.object({
    data: agenda_slot_1.getAgendaSlotItemApiSchema,
    included: zod_1.z
        .array(zod_1.z.union([
        agenda_slot_1.agendaSlotDoctorAttendingSchema,
        agenda_slot_reservation_1.agendaSlotReservationApiSchema,
        agenda_slot_reservation_1.slotReservationDoctorSubstituteSchema,
    ]))
        .optional()
        .default([]),
});
